"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authStrategy = void 0;
var _Pcas = _interopRequireDefault(require("./Pcas"));
var _Mid = _interopRequireDefault(require("./Mid2"));
var _NoAuth = _interopRequireDefault(require("./NoAuth"));
var _constants = _interopRequireDefault(require("../../constants"));
let instance = null;
class AuthStrategy {
  constructor() {
    this.connectors = {
      [_constants.default.PCAS_CONNECTOR]: _Pcas.default,
      [_constants.default.MID2_CONNECTOR]: _Mid.default
    };
    if (!instance) {
      instance = this;
    }
    this.strategy = new _NoAuth.default(() => {}, {});
    return instance;
  }
  set(connector, redirectToIndex, customLogout, config) {
    if (connector in this.connectors) {
      const Strategy = this.connectors[connector];
      instance.strategy = new Strategy(redirectToIndex, customLogout, config);
      return;
    }
    instance.strategy = new _NoAuth.default(redirectToIndex, config);
  }
  execAuthentication(...params) {
    instance.strategy.execAuthentication(...params);
  }
  redirectToLogin(...params) {
    instance.strategy.redirectToLogin(...params);
  }
  redirectToIndex(...params) {
    instance.strategy.redirectToIndex(...params);
  }
  completed(...params) {
    return instance.strategy.completed(...params);
  }
  logout(...params) {
    instance.strategy.logout(...params);
  }
}
let authStrategy = exports.authStrategy = new AuthStrategy();